import request from '@/utils/request';

// 详情接口
export function queryGroupInfo(param) {
  return request('/profile/group/queryGroupInfo', {
    method: 'POST',
    data: param,
  });
}
//查询人群详情历史列表
export function getQueryGroupHistoryPaget(param) {
  return request('/profile/group/queryGroupHistoryPage', {
    method: 'POST',
    data: param,
  });
}
// 人群启用停用状态
export function updateGroupStatus(params) {
  return request('/profile/group/updateGroupStatus', {
    method: 'POST',
    data: params,
  });
}

// 计算状态
export function updateComputeStatus(params) {
  return request('/profile/group/updateGroupComputeStatus', {
    method: 'POST',
    data: params,
  });
}
